import cmsContentMap from "../services/cms/cms-content-map";
import { CmsDocumentTypes } from "../services/cms/cms-type-definitions";

interface SpecificCmsRoute {
  type: string;
  uid: string;
  root: string;
  hideFooter?: boolean;
  hideNavigation?: boolean;
  canSlide?: boolean;
  canBeSlidOver?: boolean;
}

export const specificCmsPages: SpecificCmsRoute[] = [
  {
    uid: cmsContentMap.staticRoutes.resourcesPageUid,
    type: CmsDocumentTypes.CmsResourceThemesPage,
    root: "/resources/",
  },
  {
    type: CmsDocumentTypes.CmsReport,
    uid: cmsContentMap.teamEffectiveness.reportUid,
    root: "/teameffectivenessreport/view/",
    canSlide: true,
  },
  {
    uid: cmsContentMap.staticRoutes.teamSessionWheelUid,
    type: CmsDocumentTypes.CmsSessionWheel,
    root: "/team/wheel/",
  },
  {
    root: "/foundations/default/",
    uid: cmsContentMap.staticRoutes.foundationsSessionUid,
    type: CmsDocumentTypes.CmsSessionWithSlides,
    hideFooter: true,
    hideNavigation: true,
  },
  {
    root: "/foundations/remapping/",
    uid: cmsContentMap.staticRoutes.foundationsRemappingSessionUid,
    type: CmsDocumentTypes.CmsSessionWithSlides,
    hideFooter: true,
    hideNavigation: true,
  },
  {
    root: "/foundations/customframework/",
    uid: cmsContentMap.staticRoutes.foundationsCustomFrameworkSessionUid,
    type: CmsDocumentTypes.CmsSessionWithSlides,
    hideFooter: true,
    hideNavigation: true,
  },
  {
    root: "/foundations/hackinggames/",
    uid: cmsContentMap.staticRoutes.foundationsHackingGamesSessionUid,
    type: CmsDocumentTypes.CmsSessionWithSlides,
    hideFooter: true,
    hideNavigation: true,
  },
  {
    root: "/teamgoals",
    uid: cmsContentMap.staticRoutes.goalCapturePageUid,
    type: CmsDocumentTypes.CmsGoalCapturePage,
    hideFooter: true,
    hideNavigation: false,
    canSlide: true,
    canBeSlidOver: false,
  },
  {
    root: "/team/effectivenessquestionnaire/",
    type: CmsDocumentTypes.CmsTeamEffectivenessReview,
    uid: cmsContentMap.teamEffectiveness.questionnaireUid,
    canSlide: true,
  },
  {
    root: "/resources/session/gyreinsights-your-solo-report",
    uid: cmsContentMap.staticRoutes.gyreInsightsSoloReportUid,
    type: CmsDocumentTypes.CmsSessionWithSlides,
    hideFooter: true,
    hideNavigation: true,
    canBeSlidOver: true,
    canSlide: false,
  },
  {
    root: "/resources/session/gyreinsights-team-solo-report",
    uid: cmsContentMap.staticRoutes.gyreInsightsTeamSoloUid,
    type: CmsDocumentTypes.CmsSessionWithSlides,
    hideFooter: true,
    hideNavigation: true,
    canBeSlidOver: true,
    canSlide: false,
  },
];

export const specificUrlMap: Record<string, SpecificCmsRoute> = {};

specificCmsPages.forEach((p) => {
  specificUrlMap[`${p.type}/${p.uid}`] = p;
});
